import { Divider, Typography } from '@mui/material'
import { TruckVisitWithOrdersDto } from '@planning/app/api'
import { useSelectedGateLabel } from '@planning/pages/GateClerk/hooks/useSelectedGateLabel'
import { NavigationStackCloseButton } from '@planning/pages/TallymanV2/Components'
import { useTranslate } from '@tolgee/react'
import { ContainerMobile, Header } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { ReactNode } from 'react'

interface props {
  truckVisit?: TruckVisitWithOrdersDto | null
  children: ReactNode
}
export const TruckVisitHeaderWithAction = observer(({ truckVisit, children }: props) => {
  const { t } = useTranslate()
  const gateLabel = useSelectedGateLabel()
  const subTitle =
    [truckVisit?.truckCompany?.name, gateLabel].filter(Boolean).join(' · ') || undefined
  return (
    <>
      <Header
        title={truckVisit?.identifier ?? t('truck', 'Truck')}
        subTitle={subTitle}
        leftRenderOption={<NavigationStackCloseButton />}
        rightRenderOption={children}
      />
      <ContainerMobile sx={{ paddingY: 1 }}>
        <Typography variant='captionBold'>
          {t('checkVisitDetails', 'Check visit details')}
        </Typography>
      </ContainerMobile>
      <Divider />
    </>
  )
})
